import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import StorageUnitDTO from '../../DTOs/StorageUnit/StorageUnitDTO';
import MobileCard from './MobileCard';
import { USDollar } from '../../utilities/Constants';
import { trimDate } from '../../utilities/DateFormat';

export default function StorageUnitCardMobile(props) {
    const {
        storageUnit,
        isOwned,
        isAnonymous,
        isRequested,
        setOpenRegister,
        setOpenReserveUnit,
        setOpenCancelRequest,
        setOpenEditPayment,
        setOpenCancelUnit,
    } = props;

    const alreadyCancelled = Boolean(storageUnit.nextReadyDate);

    // The same set of conditions the previous card used, kept in one place rather than repeated on
    // each button.
    function actions() {
        if (isOwned) {
            return (
                <>
                    <Button variant={'contained'} onClick={setOpenEditPayment}>Edit Payment</Button>
                    <Button
                        variant={'outlined'}
                        color={alreadyCancelled ? 'inherit' : 'error'}
                        disabled={alreadyCancelled}
                        onClick={setOpenCancelUnit}
                    >
                        {alreadyCancelled ? 'Already Cancelled' : 'Cancel Storage Unit'}
                    </Button>
                </>
            );
        }

        if (isAnonymous) {
            return <Button variant={'contained'} onClick={() => setOpenRegister()}>Register Now</Button>;
        }

        if (isRequested) {
            return (
                <Button variant={'outlined'} color={'warning'} onClick={() => setOpenCancelRequest(true)}>
                    Cancel Request
                </Button>
            );
        }

        return <Button variant={'contained'} onClick={() => setOpenReserveUnit(true)}>Reserve</Button>;
    }

    return (
        <MobileCard
            title={`Unit ${storageUnit.name}`}
            subtitle={`${storageUnit.storageSize} \u2013 ${storageUnit.storageUnitType.name}`}
            status={isOwned && alreadyCancelled
                ? { label: 'Cancelled', color: 'warning' }
                : undefined}
            fields={[
                { label: 'Price', value: USDollar.format(storageUnit.price) },
                { label: 'Climate', value: storageUnit.climateControlled ? 'Controlled' : 'Not controlled' },
                ...(isOwned ? [] : [{
                    label: 'Available',
                    value: trimDate(storageUnit.nextReadyDate) ?? 'Now',
                }]),
            ]}
            actions={actions()}
        />
    );
}

StorageUnitCardMobile.propTypes = {
    storageUnit: PropTypes.objectOf(StorageUnitDTO),
    isOwned: PropTypes.bool,
    isAnonymous: PropTypes.bool,
    isRequested: PropTypes.bool,
    setOpenRegister: PropTypes.func,
    setOpenReserveUnit: PropTypes.func,
    setOpenCancelRequest: PropTypes.func,
    setOpenEditPayment: PropTypes.func,
    setOpenCancelUnit: PropTypes.func,
};
